<template>
    <b-col cols="12">
        <b-row>
            <b-col cols="12">
                <h4>Antes de continuar comprueba que todos los datos estén bien:</h4>
            </b-col>
            <b-col cols="12">
                <ul>
                    <li>
                        <b>Nombre: </b>{{ compania.nombre }}
                    </li>
                    <li>
                        <b>Nif: </b>{{ compania.nif }}
                    </li>
                    <li>
                        <b>Dirección: </b>{{ compania.direccion }}
                    </li>
                    <li>
                        <b>Código postal: </b>{{ compania.cp }}
                    </li>
                    <li>
                        <b>Ciudad: </b>{{ compania.ciudad }}
                    </li>
                    <li>
                        <b>Nº de cuenta: </b>{{ compania.cuenta }}
                    </li>
                </ul>
            </b-col>
            <b-col cols="12" class="text-center">
                <b-button block type="submit" :disabled="disabled">
                    <i class="fa fa-arrow-down mr-3"></i>Continuar<i class="fa fa-arrow-down ml-3"></i>
                </b-button>
                <slot></slot>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    export default {
        props: {
            compania: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                required: true
            }
        }  
    }
</script>